import { HowToRegRounded as HowToRegRoundedIcon } from '@mui/icons-material';

const Referral = (): JSX.Element => <HowToRegRoundedIcon fontSize="inherit" />;

export default Referral;
